// extracted by mini-css-extract-plugin
module.exports = {"root":"cmp-Mask__mask__root","root_active":"cmp-Mask__mask__root_active cmp-Mask__mask__root"};